import React from 'react';
import HoverButton from '../buttons/HoverButton';
import {customPriceRounding, priceFormatting} from "../../components/utils";

class LicensesSelector extends React.Component {

    constructor(props){
        super(props);
        let [totalPrice, totalPriceWithoutDiscount, discount] = this.calculatePrice(5);
        let license_number_options = this.props.discounts.map(d => d.from_number).sort(function(a, b) { return a - b; });
        this.state = {
            educator: {errors: {}, licenses_number: 5},
            isLoading: false,
            discountAmount: 0,
            totalPrice: totalPrice,
            totalPriceWithoutDiscount: totalPriceWithoutDiscount,
            discount: discount,
            license_number_options: license_number_options
        };
    }

    handleButtonOnHover = (e) => {
        const rect = e.target.getBoundingClientRect();
        const offset = {
            top: rect.top + window.scrollY,
            left: rect.left + window.scrollX,
        };
        const parentOffset = offset,
            relX = e.pageX - parentOffset.left,
            relY = e.pageY - parentOffset.top;
        if (e.target.querySelector('.button__hovered')) {
            e.target.querySelector('.button__hovered').style.top = relY + 'px';
            e.target.querySelector('.button__hovered').style.left = relX + 'px';
        }
    };

    calculatePrice = (licenses_number) => {
        if (licenses_number === 0) { return [0, 0, 0]; }
        let fullPrice = this.props.price.price * parseInt(licenses_number);
        let price = fullPrice;
        let discountPercent = 0;
        const discount = this.props.discounts.find(d => d.from_number === parseInt(licenses_number));
        if (discount) {
            discountPercent = discount.discount;
            price = discount[`price_${this.props.price.currency.code.toLowerCase()}`];
        }
        //price = customPriceRounding(price);
        fullPrice = Math.round(fullPrice * 100) / 100;
        return [price, fullPrice, discountPercent];
    };

    setLicenses = (licenses_number) => {
        let [totalPrice, totalPriceWithoutDiscount, discount] = this.calculatePrice(licenses_number);
        let newState = {totalPrice: totalPrice, totalPriceWithoutDiscount: totalPriceWithoutDiscount, discount: discount,
            educator: {...this.state.educator, licenses_number: licenses_number}};
        if (totalPrice >= 5000 ) { newState['paymentMethod'] = 'bankwire' }
        this.setState(newState);
    };

    increaseLicenses = () => {
        const current = this.state.educator.licenses_number;
        if (current === 1000) { return; }
        let currentIndex = this.state.license_number_options.indexOf(current);
        this.setLicenses(this.state.license_number_options[currentIndex+1]);

        // let step = 5;
        // if (current >= 10 && current < 50) {
        //     step = 10;
        // } else if (current >= 50 && current < 100) {
        //     step = 10;
        // } else if (current >= 100 && current < 200) {
        //     step = 25;
        // } else if (current >= 200 && current < 500) {
        //     step = 50;
        // } else if (current >= 500) {
        //     step = 100;
        // }
        // this.setLicenses(current + step);
    };

    decreaeseLicenses = () => {
        const current = this.state.educator.licenses_number;
        if (current === 5) { return; }
        let currentIndex = this.state.license_number_options.indexOf(current);
        this.setLicenses(this.state.license_number_options[currentIndex-1]);

        // let step = 5;
        // if (current > 10 && current <= 50) {
        //     step = 10;
        // } else if (current > 50 && current <= 100) {
        //     step = 10;
        // } else if (current > 100 && current <= 200) {
        //     step = 25;
        // } else if (current > 200 && current <= 500) {
        //     step = 50;
        // } else if (current > 500) {
        //     step = 100;
        // }
        // this.setLicenses(current - step);
    };

    render() {
        const curSymbol = this.props.price.currency.symbol;
        const totalPriceWithoutDiscount = this.state.totalPriceWithoutDiscount;
        const totalPrice = this.state.totalPrice;
        const licensesNumber = this.state.educator.licenses_number;
        return (
            <div className="upgrade-form for-group-licenses">
                <div className="form-container">
                    <h3>Select quantity of user licences:</h3>
                    <div className="grid-x">
                        <div className="small-3 cell flex-end">
                            <div className="group__button group__button--minus custom-button"
                                 onClick={this.decreaeseLicenses}
                                 onMouseEnter={this.handleButtonOnHover}
                            >
                                <span className="small-icon minus-icon--black"/>
                                <span className="button__hovered"/>
                            </div>
                        </div>
                        <div className="small-6 cell">
                            <div className="group__title group__title--green text-center">{licensesNumber}</div>
                        </div>
                        <div className="small-3 cell flex-start">
                            <div className="group__button group__button--plus custom-button"
                                 onClick={this.increaseLicenses}
                                 onMouseEnter={this.handleButtonOnHover}
                            >
                                <span className="small-icon plus-icon--white"/>
                                <span className="button__hovered"/>
                            </div>
                        </div>
                        <div className="small-12 cell">
                            <h3 className="text-center">Users</h3>
                        </div>
                    </div>
                </div>
                <div className="line"/>
                <div className="form-container">
                    <div className="grid-x">
                        <div className="small-3 large-4 cell">
                            <div className="group__subtitle">Value</div>
                            <div className="group__price group__price--green small-price">{priceFormatting(totalPriceWithoutDiscount, curSymbol)}</div>
                        </div>
                        <div className="small-1 cell flex-start">
                            <span className="small-icon minus-icon--black"/>
                        </div>
                        <div className="small-4 large-3 cell">
                            <div className="group__subtitle">Discount</div>
                            <div className="group__price group__price--green small-price">{this.state.discount}%</div>
                        </div>
                        <div className="small-1 cell flex-start">
                            <span className="small-icon equal-icon"/>
                        </div>
                        <div className="small-3 cell">
                            <div className="group__subtitle">Price</div>
                            <div className="group__price group__price--green small-price">{priceFormatting(totalPrice, curSymbol)}</div>
                        </div>
                        <p className="group__small group__small--text mar-top-20">
                            One licence equates to one user.
                            You can invite users via email to access the CareerHunter testing suite via your dashboard once payment has been received.
                        </p>
                    </div>
                </div>
                <div className="line"/>
                <div className="form-container">
                    <div className="grid-x">
                        <div className="small-6 cell">
                            <div  className="group__subtitle showForXsmall">Total</div>
                            <div className="group__total">
                                <div className="group__subtitle hideForXsmall">Total</div>
                                <div className="group__price group__price--green">{priceFormatting(totalPrice, curSymbol)}</div>
                                <span className="group__sup dark-grey-line-through">
                                    <span className="group__small  group__small--text">{priceFormatting(totalPriceWithoutDiscount, curSymbol)}</span>
                                </span>
                            </div>
                        </div>
                        <div className="small-6 cell group__button-container">
                            <HoverButton className="button button--green button--form prerender-link" href={`/group/checkout?licenses_number=${licensesNumber}`}>Next</HoverButton>
                        </div>
                    </div>
                </div>
            </div>
        )

    }



}
export default LicensesSelector;